function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVistrianLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 699.3973,
    y1: 1108.2261,
    x2: 699.3973,
    y2: 1107.5012,
    gradientTransform: "matrix(66.54,0,0,-66.54,-46513.8958,73738.7613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(30.980392%,30.588235%,81.568627%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(10.196078%,9.803922%,52.941176%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 699.4706,
    y1: 1107.0884,
    x2: 699.4325,
    y2: 1106.5527,
    gradientTransform: "matrix(59.1524,-4.182,-4.182,-59.1524,-36721.5521,68421.605)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(30.980392%,30.588235%,81.568627%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(16.862745%,16.470588%,61.960784%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 701.3964,
    y1: 1092.4272,
    x2: 701.3964,
    y2: 1091.0409,
    gradientTransform: "matrix(44.7,0,0,-17.0084,-31328.4232,18596.1851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 0.478431
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 0.5625 24 C 0.5625 11.058594 11.054688 0.5625 24 0.5625 C 36.941406 0.5625 47.4375 11.054688 47.4375 24 C 47.4375 36.941406 36.945312 47.4375 24.003906 47.4375 C 24.003906 47.4375 24.003906 47.4375 24 47.4375 C 11.058594 47.4375 0.5625 36.945312 0.5625 24 Z M 0.5625 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 44.886719 23.667969 C 44.886719 35.203125 35.535156 44.554688 24 44.554688 C 12.464844 44.554688 3.113281 35.203125 3.113281 23.667969 C 3.113281 12.132812 12.464844 2.78125 24 2.78125 C 35.535156 2.78125 44.886719 12.132812 44.886719 23.667969 Z M 44.886719 23.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 39.292969 23.632812 C 37.613281 23.632812 35.933594 23.640625 34.257812 23.625 C 33.941406 23.597656 33.632812 23.746094 33.464844 24.015625 C 32.230469 25.710938 30.5625 27.039062 28.636719 27.871094 L 28.46875 27.78125 C 28.582031 27.664062 28.707031 27.554688 28.8125 27.425781 C 30.347656 25.734375 30.691406 23.273438 29.675781 21.226562 C 28.746094 18.980469 26.515625 17.550781 24.085938 17.644531 C 22.335938 17.640625 20.589844 17.824219 18.878906 18.191406 C 15.042969 18.929688 11.472656 20.679688 8.539062 23.261719 C 8.433594 23.355469 8.285156 23.425781 8.234375 23.628906 C 8.304688 23.632812 8.355469 23.640625 8.40625 23.640625 C 10.253906 23.640625 12.101562 23.632812 13.945312 23.640625 C 14.191406 23.640625 14.285156 23.511719 14.402344 23.351562 C 15.636719 21.65625 17.28125 20.304688 19.183594 19.425781 C 19.289062 19.375 19.402344 19.269531 19.578125 19.355469 C 19.511719 19.429688 19.472656 19.484375 19.421875 19.53125 C 17.167969 21.847656 17.214844 25.554688 19.527344 27.808594 C 19.816406 28.089844 20.132812 28.339844 20.472656 28.558594 C 21.75 29.328125 23.230469 29.695312 24.71875 29.609375 C 29.3125 29.613281 33.792969 28.179688 37.53125 25.507812 C 38.316406 24.972656 39.046875 24.367188 39.722656 23.703125 C 39.59375 23.628906 39.4375 23.605469 39.292969 23.632812 Z M 39.292969 23.632812 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVistrianLogomark);
export default __webpack_public_path__ + "static/media/Vistrian_logomark.1e56c878560b3dedc3eb278734abff33.svg";
export { ForwardRef as ReactComponent };